var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGallery(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.8333 0.166748H3.16667C1.75 0.166748 0.666668 1.25008 0.666668 2.66675V14.3334C0.666668 15.7501 1.75 16.8334 3.16667 16.8334H14.8333C16.25 16.8334 17.3333 15.7501 17.3333 14.3334V2.66675C17.3333 1.25008 16.25 0.166748 14.8333 0.166748ZM2.33333 2.66675C2.33333 2.16675 2.66667 1.83341 3.16667 1.83341H14.8333C15.3333 1.83341 15.6667 2.16675 15.6667 2.66675V9.00008L12.9167 6.25008C12.5833 5.91675 12.0833 5.91675 11.75 6.25008L2.91667 15.0834C2.58333 15.0001 2.33333 14.6667 2.33333 14.3334V2.66675ZM5.16667 15.1667H14.8333C15.3333 15.1667 15.6667 14.8334 15.6667 14.3334V11.3334L12.3333 8.00008L5.16667 15.1667ZM6.08333 7.66675C7.25 7.66675 8.16667 6.75008 8.16667 5.58341C8.16667 4.41675 7.25 3.50008 6.08333 3.50008C4.91667 3.50008 4 4.41675 4 5.58341C4 6.75008 4.91667 7.66675 6.08333 7.66675ZM6.5 5.58341C6.5 5.33341 6.33333 5.16675 6.08333 5.16675C5.83333 5.16675 5.66667 5.33341 5.66667 5.58341C5.66667 5.83341 5.83333 6.00008 6.08333 6.00008C6.33333 6.00008 6.5 5.83341 6.5 5.58341Z",
    fill: "#263238"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGallery);
export default __webpack_public_path__ + "static/media/gallery.b6a2d95ae2ba0e252f5fb7f4705001f6.svg";
export { ForwardRef as ReactComponent };